export var DEPLOY_DATE = new Date('2026-05-20T12:33:54+0000');
